export default "__VITE_ASSET__CmO1$Tfu__"